import { render, staticRenderFns } from "./MyCSSBackground.vue?vue&type=template&id=29f6df94&scoped=true&"
import script from "./MyCSSBackground.vue?vue&type=script&lang=js&"
export * from "./MyCSSBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f6df94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29f6df94')) {
      api.createRecord('29f6df94', component.options)
    } else {
      api.reload('29f6df94', component.options)
    }
    module.hot.accept("./MyCSSBackground.vue?vue&type=template&id=29f6df94&scoped=true&", function () {
      api.rerender('29f6df94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyCSSBackground.vue"
export default component.exports